/**
 * @fileOverview: Leaderboard Service
 * This service is responsible for fetching the leaderboard data from the API.
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { firstValueFrom } from 'rxjs';

/**
 *
 */
@Injectable({
  providedIn: 'root'
})
export class LeaderboardService {

  /**
   *
   * @param httpClient
   */
  constructor(
    protected httpClient: HttpClient
  ) { }

  /**
   *
   * @param duration
   */
  getLeaderboardDrivers(duration: string = 'monthly'): Promise<any> {
    let baseUrl = environment.leaderboardFetchUrl;
    return firstValueFrom(this.httpClient.get(`${baseUrl}/${duration}`)).then((response: any) => {
      return response;
    });
  }
}
